// extracted by mini-css-extract-plugin
export default {"container":"_2MaCJ","noSeparators":"_1rjgP","section":"_3HCJ3","socialActions":"_1J-gM","mainSection":"_2oeUd","bottomSection":"_1TzVu","stats":"g7Wot","comments":"_2xWt6"};